// Chronotunnel: a letter-tunnel flight (from the Second Opus demo) carrying a
// personal timeline. Full narrative text overlay comes with the ported module.
import type { Scene } from './Engine';
import { HDR, deleteProgram, type Program } from './gl';

const FS = HDR + `
void main(){
  vec2 uv=(gl_FragCoord.xy-.5*R)/R.y;
  vec2 ctr=vec2(sin(T*.5)*.12,cos(T*.4)*.08);
  vec2 q=(uv-ctr)*rot(sin(T*.2)*.5);
  float r=max(length(q),1e-3), an=atan(q.y,q.x);
  float z=.3/r, v=z+T*1.6, seg=16.;
  float u=(an/(2.*PI)+.5+T*.02)*seg;
  vec2 cell=vec2(mod(floor(u),seg),floor(v)), f=vec2(fract(u),fract(v));
  vec3 col=vec3(.1,.12,.28)+.05*h21(cell);
  float pxU=seg/(2.*PI*r*R.y), pxV=.3/(r*r*R.y);
  float dU=min(f.x,1.-f.x)/pxU, dV=min(f.y,1.-f.y)/pxV;
  float pulse=mod(cell.y,4.)==mod(floor(BT),4.)?K*1.5:0.;
  col+=vec3(.3,.9,.5)*((exp(-dU*.6)+exp(-dV*.6)*(1.+pulse))*.7+(exp(-dU*.08)+exp(-dV*.08))*.1);
  col*=smoothstep(0.,.3,r)*.85+.15;
  col+=vec3(.4,1.,.6)*exp(-abs(r-.06)*70.)*(.6+K);
  O=vec4(col,1.);
}`;

export default function chronotunnel(): Scene {
  let p: Program;
  return {
    scale: .8, bloom: .9, crt: .5,
    init(e) { p = e.prog(FS); },
    frame(f) { f.e.fullscreen(p, f); },
    dispose(e) { deleteProgram(e.gl, p); },
  };
}
